import React from "react";
import { SectionShell, TextField, AreaField, UrlField } from "./SectionShell";
import { ListEditor } from "./ListEditor";
import { ImageSlotField } from "./ImageSlotField";

export function GalleryEditor({ data, set, max = 12 }) {
  return (
    <SectionShell title="Galeri" description="Foto fasilitas, produk, tim, atau kegiatan. Item tanpa gambar tidak disimpan." enabled={data.enabled} onToggle={(v) => set({ enabled: v })} testId="cp-editor-gallery">
      <TextField label="Judul section" value={data.title} onChange={(v) => set({ title: v })} placeholder="Galeri Kami" testId="cp-gallery-title" />
      <ListEditor items={data.images || []} max={max} onChange={(images) => set({ images })} newItem={() => ({ image: "", caption: "" })} addLabel="Tambah foto" testId="cp-gallery-items"
        renderItem={(it, update, i) => (
          <div className="grid gap-3 md:grid-cols-2">
            <ImageSlotField slot="gallery" label="Gambar" value={it.image} onChange={(v) => update({ image: v })} testId={`cp-gallery-image-${i}`} />
            <TextField label="Keterangan (opsional)" value={it.caption} onChange={(v) => update({ caption: v })} testId={`cp-gallery-caption-${i}`} />
          </div>
        )} />
    </SectionShell>
  );
}

export function StatsEditor({ data, set, max = 6 }) {
  return (
    <SectionShell title="Statistik" description="Angka nyata milik perusahaan Anda (mis. tahun berdiri, jumlah mitra). Tidak ada angka bawaan — hanya yang Anda isi yang tampil." enabled={data.enabled} onToggle={(v) => set({ enabled: v })} testId="cp-editor-stats">
      <TextField label="Judul section (opsional)" value={data.title} onChange={(v) => set({ title: v })} testId="cp-stats-title" />
      <ListEditor items={data.items || []} max={max} onChange={(items) => set({ items })} newItem={() => ({ value: "", label: "" })} addLabel="Tambah angka" testId="cp-stats-items"
        renderItem={(it, update, i) => (
          <div className="grid gap-3 md:grid-cols-2">
            <TextField label="Nilai" value={it.value} maxLength={24} onChange={(v) => update({ value: v })} placeholder="mis. 2005 atau 120+" testId={`cp-stat-value-${i}`} />
            <TextField label="Label" value={it.label} maxLength={60} onChange={(v) => update({ label: v })} placeholder="mis. Tahun berdiri" testId={`cp-stat-label-${i}`} />
          </div>
        )} />
    </SectionShell>
  );
}

export function FaqEditor({ data, set, max = 20 }) {
  return (
    <SectionShell title="FAQ" description="Pertanyaan yang sering diajukan. Item dengan pertanyaan & jawaban lengkap juga dipublikasikan sebagai data terstruktur FAQ." enabled={data.enabled} onToggle={(v) => set({ enabled: v })} testId="cp-editor-faq">
      <TextField label="Judul section" value={data.title} onChange={(v) => set({ title: v })} placeholder="Pertanyaan yang Sering Diajukan" testId="cp-faq-title" />
      <ListEditor items={data.items || []} max={max} onChange={(items) => set({ items })} newItem={() => ({ question: "", answer: "" })} addLabel="Tambah pertanyaan" testId="cp-faq-items"
        renderItem={(it, update, i) => (
          <div className="grid gap-3">
            <TextField label="Pertanyaan" value={it.question} maxLength={400} onChange={(v) => update({ question: v })} testId={`cp-faq-q-${i}`} />
            <AreaField label="Jawaban" value={it.answer} rows={3} onChange={(v) => update({ answer: v })} testId={`cp-faq-a-${i}`} />
          </div>
        )} />
    </SectionShell>
  );
}

export function LocationEditor({ data, set, contact = {} }) {
  const fb = (k) => (contact?.[k] ? `Kosong → memakai Branding: ${contact[k]}` : undefined);
  return (
    <SectionShell title="Lokasi & Kontak" description="Nilai di sini diprioritaskan. Field yang kosong otomatis memakai data Kontak dari Pengaturan Branding." enabled={data.enabled} onToggle={(v) => set({ enabled: v })} testId="cp-editor-location">
      <TextField label="Judul section" value={data.title} onChange={(v) => set({ title: v })} placeholder="Kunjungi atau Hubungi Kami" testId="cp-loc-title" />
      <AreaField label="Alamat" value={data.address} maxLength={400} rows={3} onChange={(v) => set({ address: v })} testId="cp-loc-address" hint={fb("address")} />
      <AreaField label="Jam operasional" value={data.hours} maxLength={400} rows={2} onChange={(v) => set({ hours: v })} placeholder={"Senin–Jumat 08.00–17.00\nSabtu 08.00–13.00"} testId="cp-loc-hours" />
      <div className="grid gap-4 md:grid-cols-2">
        <TextField label="Telepon" value={data.phone} maxLength={30} onChange={(v) => set({ phone: v })} placeholder="021-xxxxxxx" testId="cp-loc-phone" />
        <TextField label="WhatsApp (angka, awali 62)" value={data.whatsapp} maxLength={20} onChange={(v) => set({ whatsapp: v.replace(/\D/g, "") })} placeholder="628xxxxxxxxx" testId="cp-loc-whatsapp" hint={fb("whatsapp")} />
        <TextField label="Email" value={data.email} onChange={(v) => set({ email: v })} placeholder="halo@perusahaan.com" testId="cp-loc-email" hint={fb("email")} />
        <UrlField label="Tautan peta (Google Maps)" value={data.maps_url} onChange={(v) => set({ maps_url: v })} placeholder="https://maps.google.com/…" testId="cp-loc-maps" hint={fb("maps_url")} />
      </div>
    </SectionShell>
  );
}
